const DAY_MS = 24 * 60 * 60 * 1000;

export function parseIsoDate(value) {
  if (!value) {
    return null;
  }

  return new Date(`${value}T12:00:00`);
}

function createLocalDate(year, monthIndex, day) {
  return new Date(year, monthIndex, day, 12, 0, 0, 0);
}

export function buildRange(year, zoomMonth = null) {
  if (zoomMonth !== null && zoomMonth !== undefined) {
    const start = createLocalDate(year, zoomMonth, 1);
    const end = createLocalDate(year, zoomMonth + 1, 0);
    return {
      start,
      end,
      totalDays: getInclusiveDays(start, end),
    };
  }

  const start = createLocalDate(year, 0, 1);
  const end = createLocalDate(year, 11, 31);

  return {
    start,
    end,
    totalDays: getInclusiveDays(start, end),
  };
}

export function getInclusiveDays(start, end) {
  return Math.round((end.getTime() - start.getTime()) / DAY_MS) + 1;
}

export function getOffsetPercent(date, range) {
  if (!date || !range || !range.totalDays) {
    return 0;
  }

  return (Math.round((date.getTime() - range.start.getTime()) / DAY_MS) / range.totalDays) * 100;
}

export function getWidthPercent(start, end, range) {
  if (!start || !end || !range || !range.totalDays) {
    return 0;
  }

  return (getInclusiveDays(start, end) / range.totalDays) * 100;
}

export function clipItemToRange(item, range) {
  const start = parseIsoDate(item && item.realizationStart);
  const end = parseIsoDate(item && item.realizationEnd);

  if (!start || !end || end.getTime() < range.start.getTime() || start.getTime() > range.end.getTime()) {
    return null;
  }

  const clippedStart = start.getTime() < range.start.getTime() ? range.start : start;
  const clippedEnd = end.getTime() > range.end.getTime() ? range.end : end;

  return {
    ...item,
    start,
    end,
    clippedStart,
    clippedEnd,
    startsBeforeRange: start.getTime() < range.start.getTime(),
    endsAfterRange: end.getTime() > range.end.getTime(),
    isSingleDay: start.toDateString() === end.toDateString(),
  };
}

export function packLanes(items, range) {
  const preparedItems = (items || [])
    .map((item) => clipItemToRange(item, range))
    .filter((item) => !!item)
    .sort((left, right) => {
      if (left.clippedStart.getTime() !== right.clippedStart.getTime()) {
        return left.clippedStart.getTime() - right.clippedStart.getTime();
      }

      if (left.clippedEnd.getTime() !== right.clippedEnd.getTime()) {
        return left.clippedEnd.getTime() - right.clippedEnd.getTime();
      }

      return (left.id || 0) - (right.id || 0);
    });

  const laneEndTimes = [];
  const itemsWithLane = preparedItems.map((item) => {
    let laneIndex = laneEndTimes.findIndex((endTime) => item.clippedStart.getTime() > endTime);

    if (laneIndex === -1) {
      laneIndex = laneEndTimes.length;
      laneEndTimes.push(item.clippedEnd.getTime());
    } else {
      laneEndTimes[laneIndex] = item.clippedEnd.getTime();
    }

    return {
      ...item,
      lane: laneIndex,
    };
  });

  return {
    itemsWithLane,
    laneCount: Math.max(laneEndTimes.length, 1),
  };
}
